const STORAGE_KEY = "pwa_install_dismissed";
const DAILY_MS = 24 * 60 * 60 * 1000;
const WEEKLY_MS = 7 * 24 * 60 * 60 * 1000;

function isLegacyBrowserWideValue(raw) {
  if (raw == null || raw === "") return false;
  if (raw === "true") return true;
  if (raw.charAt(0) === "w") return /^\d+$/.test(raw.slice(1));
  return /^\d+$/.test(raw);
}

function readAllRecords() {
  if (typeof window === "undefined") return {};
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return {};

  // 旧版按浏览器记一条字符串，不能套到任何账号上
  if (isLegacyBrowserWideValue(raw)) {
    localStorage.removeItem(STORAGE_KEY);
    return {};
  }

  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    return parsed;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return {};
  }
}

function writeAllRecords(records) {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
}

function getUserRecord(userId) {
  if (userId == null || userId === "") return null;
  const row = readAllRecords()[String(userId)];
  if (!row || typeof row !== "object") return null;
  return row;
}

export function shouldShowPwaInstallPrompt(userId) {
  if (userId == null || userId === "") return false;
  const row = getUserRecord(userId);
  if (!row) return true;

  const lastShownAt = Number(row.lastShownAt);
  if (!Number.isFinite(lastShownAt)) return true;

  const interval = row.weekly ? WEEKLY_MS : DAILY_MS;
  if (Date.now() - lastShownAt < interval) return false;

  const all = readAllRecords();
  delete all[String(userId)];
  writeAllRecords(all);
  return true;
}

export function markPwaInstallPromptDismissed(userId, weekly = false) {
  if (userId == null || userId === "") return;
  const all = readAllRecords();
  all[String(userId)] = { lastShownAt: Date.now(), weekly: !!weekly };
  writeAllRecords(all);
}
